import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Flex,
  Input,
  Text,
  Button,
  List,
  Divider,
  ListItem,
  VStack,
  Textarea,
  Switch,
  StackDivider,// Import Divider to add separators between suggestions
  useToast,
} from "@chakra-ui/react";

import { constants } from "constants/constants";
import Card from "components/card/Card";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
export default function ProductUpdate() {
  const [isLoading, setIsLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  const [tagsData, setTagsData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [existingCategories, SetExistingCategoriesData] = useState([]);
  const [existingTags, SetExistingTagsData] = useState([]);
  const [existingCountryOrigin, SetExistingCountryOrigin] = useState("");
  const [countryOrigin, SetCountryOrigin] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isAddCategoryOpen, setAddCategoryOpen] = useState(false);
  const [productPermissions, setProductPermissions] = useState({});
  const toast = useToast();
  const [suggestions, setSuggestions] = useState([]);
  const [productData, setProductData] = useState({
    partNo: "",
    description: "",
    barcode: "",
    binLocation: "",
    sellPrice: "",
    rrp: ""
  });

  const CategoryDropdown = ({ categories, onSelectCategory }) => {
    console.log(categories);


    const handleSelectChange = (selectedOptions) => {
      SetExistingCategoriesData(selectedOptions);
      onSelectCategory(selectedOptions);
    };

    return (
      <Box>
        <Text fontWeight="bold">Product Categories:</Text>
        <Select
          value={categories}
          onChange={handleSelectChange}
          options={categories.map((category) => ({ value: category, label: category }))}
          isMulti
          isClearable
        />
      </Box>
    );
  };

  const AddCategoryDropdown = ({ parentCategories, onSelectParentCategory, onAddCategories, isDisabledSelection }) => {
    console.log(isDisabledSelection);
    const [selectedParentCategory, setSelectedParentCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedSubSubCategory, setSelectedSubSubCategory] = useState(null);
    const [newCategory, setNewCategory] = useState("");

    const handleParentCategoryChange = (selectedOption) => {
      setSelectedParentCategory(selectedOption);
      onSelectParentCategory(selectedOption);
      setSelectedSubCategory(null);
      setSelectedSubSubCategory(null); // Clear sub-sub category when parent category changes
    };

    const handleSubCategoryChange = (selectedOption) => {
      setSelectedSubCategory(selectedOption);
      setSelectedSubSubCategory(null);
    };

    const handleSubSubCategoryChange = (selectedOption) => {
      setSelectedSubSubCategory(selectedOption);
    };

    const handleCreateCategory = (inputValue) => {
      setNewCategory(inputValue);
      setSelectedParentCategory({ value: inputValue, label: inputValue });
      onSelectParentCategory(null);
      setSelectedSubCategory(null);
      setSelectedSubSubCategory(null);
    };

    const handleSubCreateCategory = (inputValue) => {
      setNewCategory(inputValue);
      setSelectedSubCategory({ value: inputValue, label: inputValue });
      setSelectedSubSubCategory(null);
    };

    const handleSubSubCreateCategory = (inputValue) => {
      setNewCategory(inputValue);
      setSelectedSubSubCategory({ value: inputValue, label: inputValue });
    };

    const handleAddCategories = () => {
      // Combine selected categories into a string
      const combinedCategories = [selectedParentCategory, selectedSubCategory, selectedSubSubCategory]
        .filter((category) => category)
        .map((category) => category.label)
        .join('>');

      // Add the combined string to existingCategories
      onAddCategories(combinedCategories);
    };

    const subCategories = parentCategories.filter(
      (category) => category.parentCategoryId === selectedParentCategory?.value
    );

    const subSubCategories = parentCategories.filter(
      (category) => category.parentCategoryId === selectedSubCategory?.value
    );

     

    return (
      <Flex justify={"space-between"} marginRight={4}>

        <CreatableSelect
          value={selectedParentCategory}
          onChange={handleParentCategoryChange}
          options={parentCategories
            .filter((category) => category.parentCategoryId === 0)
            .map((category) => ({
              value: category.categoryId,
              label: category.category,
            }))}
          isClearable
          onCreateOption={handleCreateCategory}
          isDisabled={isDisabledSelection}
        />
        <Box width="4" /> {/* Adjust the width to set the space */}
        <CreatableSelect
          placeholder="Sub Category"
          value={selectedSubCategory}
          onChange={handleSubCategoryChange}
          options={subCategories.map((subCategory) => ({
            value: subCategory.categoryId,
            label: subCategory.category,
          }))}
          isClearable
          onCreateOption={handleSubCreateCategory}
          isDisabled={isDisabledSelection}
        />
        <Box width="4" /> {/* Adjust the width to set the space */}
        <CreatableSelect
          placeholder="Sub Sub Category"
          value={selectedSubSubCategory}
          onChange={handleSubSubCategoryChange}
          options={subSubCategories.map((subSubCategory) => ({
            value: subSubCategory.categoryId,
            label: subSubCategory.category,
          }))}
          isClearable
          onCreateOption={handleSubSubCreateCategory}
          isDisabled={isDisabledSelection}
        />
        <Box width="4" /> {/* Adjust the width to set the space */}
        <Button colorScheme="teal" onClick={handleAddCategories} disabled={isDisabledSelection} >Add</Button>
      </Flex>
    );
  };





  const [changedData, setChangedData] = useState({});
  const handleChange = (key, value) => {
    setChangedData((prevData) => {
      const updatedData = {
        ...prevData,
        [key]: value,
      };


      // Calculate Cubic if Length, Width, or Height is changed
      if (key === "Length" || key === "Width" || key === "Height") {
        const { Length, Width, Height } = updatedData;

        const cubic = (Width * Length * Height) / 1000000;

        updatedData.Cubic = cubic.toFixed(6); // Adjust the precision as needed
      }

      // if (key === "AZDF" || key === "AZDC" || key === "MyDeal" || key === "EDLP" || key === "WHS" || key === "Revlon" || key === "KoganEDI") {
      //  updatedData[key] = value ? 1 : 0;
      // }

      // If the value is empty, remove it from updatedData
      if (value === "" && key === "LongDescription") {
        delete updatedData[key];
      }

      return updatedData;
    });
  };


  const [selectedCategories, setSelectedCategories] = useState([responseData.ProductCategories]);

  const handleSelectCategory = (selectedOptions) => {
    const nonEmptyCategories = selectedOptions.filter(option => option.value.trim() !== "");
    SetExistingCategoriesData(nonEmptyCategories.map(option => option.value));
    handleChange("ProductCategories", nonEmptyCategories.map(option => option.value).join(","));
  };





  const handleSelectTagChange = (selectedOptions) => {
    SetExistingTagsData(selectedOptions.map(option => option.value));
    handleChange("ProductTags", selectedOptions.map((option) => option.value).join(","));
  };

  const handleSelectCountryOfOriginChange = (selectedOptions) => {
    SetExistingCountryOrigin(selectedOptions ? selectedOptions.value : null);
    handleChange("countryofOrigin", selectedOptions ? selectedOptions.value : null);
  };


  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.length >= 3) {
      const token = localStorage.getItem("accessToken");

      if (!token) {
        return;
      }

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .get(`${constants.apiUrl}/fetch-product-details?searchText=${value}`, {
          headers,
          withCredentials: true,
        })
        .then((response) => {
          setSuggestions(response.data);
        })
        .catch((error) => {
          console.error("Error fetching suggestions:", error);

          setSuggestions([]);
        });
    } else {
      setSuggestions([]);
    }
  };

  const handleSuggestionSelect = (suggestion) => {
    setProductData(suggestion);
    setSuggestions([]);
    setSearchText(suggestion.partNo);
    handleSearch(suggestion)
    // setResponseData({});
  };

  const handleSearch = (suggestion) => {
    setIsLoading(true);
    const token = localStorage.getItem("accessToken");

    if (!token) {

      setIsLoading(false);
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(`${constants.apiUrl}/product-update-details`, {
        headers,
        withCredentials: true,
        params: {
          partNo: suggestion.partNo,
        },
      })
      .then((response) => {
        const responseData = response.data.records;
        // console.log('responseData', responseData[0]);
        setResponseData(responseData);
        setChangedData(responseData);
        setCategoryData(response.data.categories);
        if (responseData.ProductCategories !== "") {
          const categoriesString = responseData.ProductCategories;
          const catArr = categoriesString.split(",").map((category) => category);
          SetExistingCategoriesData(catArr);
        }

        const TagString = responseData.ProductTags;
        const tagsArr = TagString.split(",").map((tag) => tag);
        SetExistingTagsData(tagsArr);
        setTagsData(response.data.tags);
        SetExistingCountryOrigin(responseData.countryofOrigin);
        SetCountryOrigin(response.data.countyOfOrigin);
        setProductPermissions(response.data.productPermissions);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        setIsLoading(false);
        setResponseData([]);
      });
  };

  const handleAddCategories = (combinedCategories) => {
    // Check if combinedCategories is not empty
    if (combinedCategories.trim() !== "") {
      // Add the combined string to existingCategories
      SetExistingCategoriesData((prevCategories) => [...prevCategories, combinedCategories]);
      // Use the updated state directly to get the combined list
      const selectedCategoriesString = [...existingCategories, combinedCategories].join(",");
      handleChange("ProductCategories", selectedCategoriesString);
    }
  };



  const submitProductdata = () => {
    setIsLoading(true);
    const token = localStorage.getItem("accessToken");

    if (!token) {

      setIsLoading(false);
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    changedData.partNo = productData.partNo;
    changedData.Barcode = productData.barcode;
    axios
      .post(`${constants.apiUrl}/submit-product-update`, changedData, {
        headers: headers, // Pass headers in the request config
        withCredentials: true,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.success) {
          toast({
            position: "bottom-right",
            title: "Product updated successfully",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error submiting Product Update:", error);
        toast({
          position: "bottom-right",
          title: "Error submiting Product Update",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
      });
  };
 // Check if any value in productPermissions has the value "edit"
 const hasEditPermission = Object.values(productPermissions).includes('edit');
  return (
    <Card mt={4} p={4} backgroundColor="white">
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <Box>
          <List spacing={2}>
            <ListItem>
              <Flex justify="center" alignItems="center">
                <Input
                  type="text"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearchChange}
                  mr={2}
                />
              </Flex>
            </ListItem>
          </List>
          <Box mb={6}>
            <List spacing={0}>
              {suggestions.length > 0 && (
                <VStack spacing={0} borderRadius={10} align="start" width={"92%"} border="1px solid #e2e8f0" divider={<StackDivider borderColor='gray.200' />}>
                  {suggestions.map((suggestion, index) => (
                    <Box key={suggestion.partNo}>
                      <ListItem
                        onClick={() => handleSuggestionSelect(suggestion)}
                        cursor="pointer"
                        // _hover={{ backgroundColor: "gray.200" }}
                        ml={2}
                        py={2} // Add padding to each suggestion
                      >
                        {suggestion.sku} - {" "} {suggestion.partNo} - {suggestion.description} -{" "}
                        {suggestion.barcode}
                      </ListItem>
                      {index < suggestions.length - 1 && (
                        <StackDivider borderColor="gray.200" />
                      )}
                    </Box>
                  ))}
                </VStack>
              )}
            </List>
          </Box>
        </Box>

        <Flex justify="space-between">
          <Box>
            <Text fontWeight="bold">Inventory ID:</Text>
            <Text>{productData.sku}</Text>
          </Box>
          <Box>
            <Text fontWeight="bold">Part No:</Text>
            <Text>{productData.partNo}</Text>
          </Box>
          <Box>
            <Text fontWeight="bold">Description:</Text>
            <Text>{productData.description}</Text>
          </Box>
          <Box>
            <Text fontWeight="bold">UPC/Barcode:</Text>
            <Text>{productData.barcode}</Text>
          </Box>

        </Flex>

        {/* Prices Section */}
        {Object.keys(responseData).length !== 0 && (
          <Box>
            {/* Prices Section */}
            <Flex justify="space-between" mt={4} mb={4}>
              {productPermissions.hasOwnProperty("DefaultPrice") && productPermissions.DefaultPrice !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">Regular Price:</Text>

                  {/* Check if the permission for "DefaultPrice" is "view" or "edit" */}
                  {productPermissions.DefaultPrice === "view" ? (
                    // If the permission is "view", render the input as read-only
                    <Input
                      type="number"
                      value={changedData.DefaultPrice || responseData.DefaultPrice}
                      isReadOnly
                      placeholder="Regular Price"
                    />
                  ) : (
                    // If the permission is "edit", render the input as editable
                    <Input
                      type="number"
                      value={changedData.DefaultPrice || responseData.DefaultPrice}
                      onChange={(e) => handleChange("DefaultPrice", e.target.value)}
                      placeholder="Regular Price"
                    />
                  )}
                </Box>
              )}

              {/* Kogan Default Price */}
              {productPermissions.hasOwnProperty("KoganDefaultPrice") && productPermissions.KoganDefaultPrice !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">Kogan Default Price:</Text>
                  {productPermissions.KoganDefaultPrice === "view" ? (
                    <Input
                      type="number"
                      value={changedData.KoganDefaultPrice || responseData.KoganDefaultPrice}
                      isReadOnly
                      placeholder="Kogan Default Price"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.KoganDefaultPrice || responseData.KoganDefaultPrice}
                      onChange={(e) => handleChange("KoganDefaultPrice", e.target.value)}
                      placeholder="Kogan Default Price"
                    />
                  )}
                </Box>
              )}

              {/* RRP */}
              {productPermissions.hasOwnProperty("RRPPrice") && productPermissions.RRPPrice !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">RRP:</Text>
                  {productPermissions.RRPPrice === "view" ? (
                    <Input
                      type="number"
                      value={changedData.RRPPrice || responseData.RRPPrice}
                      isReadOnly
                      placeholder="RRP"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.RRPPrice || responseData.RRPPrice}
                      onChange={(e) => handleChange("RRPPrice", e.target.value)}
                      placeholder="RRP"
                    />
                  )}
                </Box>
              )}

              {/* Beauty Mania Price */}
              {productPermissions.hasOwnProperty("BeautyManiaDefaultPrice") && productPermissions.BeautyManiaDefaultPrice !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">Beauty Mania Price:</Text>
                  {productPermissions.BeautyManiaDefaultPrice === "view" ? (
                    <Input
                      type="number"
                      value={changedData.BeautyManiaDefaultPrice || responseData.BeautyManiaDefaultPrice}
                      isReadOnly
                      placeholder="Beauty Mania Price"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.BeautyManiaDefaultPrice || responseData.BeautyManiaDefaultPrice}
                      onChange={(e) => handleChange("BeautyManiaDefaultPrice", e.target.value)}
                      placeholder="Beauty Mania Price"
                    />
                  )}
                </Box>
              )}

              {/* P1 */}
              {productPermissions.hasOwnProperty("P1") && productPermissions.P1 !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">P1:</Text>
                  {productPermissions.P1 === "view" ? (
                    <Input
                      type="number"
                      value={changedData.P1 || responseData.P1}
                      isReadOnly
                      placeholder="P1"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.P1 || responseData.P1}
                      onChange={(e) => handleChange("P1", e.target.value)}
                      placeholder="P1"
                    />
                  )}
                </Box>
              )}

              {/* Landing Cost */}
              {productPermissions.hasOwnProperty("LCost") && productPermissions.LCost !== "hide" && (
                <Box style={{ marginRight: "8px" }}>
                  <Text fontWeight="bold">Landing Cost:</Text>
                  {productPermissions.LCost === "view" ? (
                    <Input
                      type="number"
                      value={changedData.LCost || responseData.LCost}
                      isReadOnly
                      placeholder="Landing Cost"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.LCost || responseData.LCost}
                      onChange={(e) => handleChange("LCost", e.target.value)}
                      placeholder="Landing Cost"
                    />
                  )}
                </Box>
              )}

              {/* MyDeal Price */}
              {productPermissions.hasOwnProperty("MyDealPrice") && productPermissions.MyDealPrice !== "hide" && (
                <Box>
                  <Text fontWeight="bold">MyDeal Price:</Text>
                  {productPermissions.MyDealPrice === "view" ? (
                    <Input
                      type="number"
                      value={changedData.MyDealPrice || responseData.MyDealPrice}
                      isReadOnly
                      placeholder="MyDeal Price"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.MyDealPrice || responseData.MyDealPrice}
                      onChange={(e) => handleChange("MyDealPrice", e.target.value)}
                      placeholder="MyDeal Price"
                    />
                  )}
                </Box>
              )}

            </Flex>
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            {/* Dimensions Section */}

            <Flex justify="space-between" mb={4}>
              {/* Length */}
              {productPermissions.hasOwnProperty("Length") && productPermissions.Length !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Length:</Text>
                  {productPermissions.Length === "view" ? (
                    <Input
                      type="number"
                      value={changedData.Length || responseData.Length}
                      isReadOnly
                      placeholder="Length"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.Length || responseData.Length}
                      onChange={(e) => handleChange("Length", e.target.value)}
                      placeholder="Length"
                    />
                  )}
                </Box>
              )}

              {/* Width */}
              {productPermissions.hasOwnProperty("Width") && productPermissions.Width !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Width:</Text>
                  {productPermissions.Width === "view" ? (
                    <Input
                      type="number"
                      value={changedData.Width || responseData.Width}
                      isReadOnly
                      placeholder="Width"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.Width || responseData.Width}
                      onChange={(e) => handleChange("Width", e.target.value)}
                      placeholder="Width"
                    />
                  )}
                </Box>
              )}

              {/* Height */}
              {productPermissions.hasOwnProperty("Height") && productPermissions.Height !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Height:</Text>
                  {productPermissions.Height === "view" ? (
                    <Input
                      type="number"
                      value={changedData.Height || responseData.Height}
                      isReadOnly
                      placeholder="Height"
                    />
                  ) : (
                    <Input
                      type="number"
                      value={changedData.Height || responseData.Height}
                      onChange={(e) => handleChange("Height", e.target.value)}
                      placeholder="Height"
                    />
                  )}
                </Box>
              )}

              {/* Cubic */}
              {productPermissions.hasOwnProperty("Cubic") && productPermissions.Cubic !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Cubic:</Text>
                  {productPermissions.Cubic === "view" ? (
                    <Input
                      type="text"
                      value={changedData.Cubic || responseData.Cubic}
                      isReadOnly
                      placeholder="Cubic"
                    />
                  ) : (
                    <Input
                      type="text"
                      value={changedData.Cubic || responseData.Cubic}
                      onChange={(e) => handleChange("Cubic", e.target.value)}
                      placeholder="Cubic"
                      isReadOnly
                    />
                  )}
                </Box>
              )}

            </Flex>
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            <Flex justify="space-between" mb={4}>
              <Box>
                <Text fontWeight="bold">Brands:</Text>
                <Text>{responseData.BrandName}</Text>
              </Box>
              {/* Tags Field */}
              {productPermissions.hasOwnProperty("ProductTags") && productPermissions.ProductTags !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Tags:</Text>
                  {productPermissions.ProductTags === "view" ? (
                    <Select
                      value={existingTags.map((tag) => ({
                        value: tag,
                        label: tag,
                      }))}
                      isMulti
                      isClearable
                      isDisabled
                    />
                  ) : productPermissions.ProductTags === "edit" ? (
                    <Select
                      value={existingTags.map((tag) => ({
                        value: tag,
                        label: tag,
                      }))}
                      onChange={handleSelectTagChange}
                      options={tagsData.map((tag) => ({ value: tag, label: tag }))}
                      isMulti
                      isClearable
                    />
                  ) : null}
                </Box>
              )}

              {/* Kogan Category Field */}
              {productPermissions.hasOwnProperty("KoganCategory") && productPermissions.KoganCategory !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Kogan Category:</Text>
                  {productPermissions.KoganCategory === "view" ? (
                    <Input
                      type="text"
                      value={changedData.KoganCategory || responseData.KoganCategory}
                      isReadOnly
                      placeholder="Kogan Category"
                    />
                  ) : productPermissions.KoganCategory === "edit" ? (
                    <Input
                      type="text"
                      value={changedData.KoganCategory || responseData.KoganCategory}
                      onChange={(e) => handleChange("KoganCategory", e.target.value)}
                      placeholder="Kogan Category"
                    />
                  ) : null}
                </Box>
              )}

              {/* MyDeal Category Field */}
              {productPermissions.hasOwnProperty("MyDealCategory") && productPermissions.MyDealCategory !== "hide" && (
                <Box>
                  <Text fontWeight="bold">MyDeal Category:</Text>
                  {productPermissions.MyDealCategory === "view" ? (
                    <Input
                      type="text"
                      value={changedData.MyDealCategory || responseData.MyDealCategory}
                      isReadOnly
                      placeholder="MyDeal Category"
                    />
                  ) : productPermissions.MyDealCategory === "edit" ? (
                    <Input
                      type="text"
                      value={changedData.MyDealCategory || responseData.MyDealCategory}
                      onChange={(e) => handleChange("MyDealCategory", e.target.value)}
                      placeholder="MyDeal Category"
                    />
                  ) : null}
                </Box>
              )}

            </Flex>
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            <Text fontWeight="bold" mb={2}>Enabled For:</Text>
            <Flex justify="space-between" mb={4}>

              <Box>
                <Text fontWeight="semibold">Web:</Text>
                <Switch
                  colorScheme="teal"
                  isChecked={responseData.WebEnabled}
                  disabled={true}
                />
              </Box>
              {/* Amazon DC */}
              {productPermissions.hasOwnProperty("AZDC") && productPermissions.AZDC !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">Amazon DC:</Text>
                  {productPermissions.AZDC === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.AZDC !== undefined ? changedData.AZDC : responseData.AZDC}
                      isReadOnly
                    />
                  ) : productPermissions.AZDC === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.AZDC !== undefined ? changedData.AZDC : responseData.AZDC}
                      onChange={e => handleChange("AZDC", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

              {/* Amazon DF */}
              {productPermissions.hasOwnProperty("AZDF") && productPermissions.AZDF !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">Amazon DF:</Text>
                  {productPermissions.AZDF === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.AZDF !== undefined ? changedData.AZDF : responseData.AZDF}
                      isReadOnly
                    />
                  ) : productPermissions.AZDF === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.AZDF !== undefined ? changedData.AZDF : responseData.AZDF}
                      onChange={e => handleChange("AZDF", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

              {/* Kogan */}
              {productPermissions.hasOwnProperty("KoganEDI") && productPermissions.KoganEDI !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">Kogan:</Text>
                  {productPermissions.KoganEDI === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.KoganEDI !== undefined ? changedData.KoganEDI : responseData.KoganEDI}
                      isReadOnly
                    />
                  ) : productPermissions.KoganEDI === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.KoganEDI !== undefined ? changedData.KoganEDI : responseData.KoganEDI}
                      onChange={e => handleChange("KoganEDI", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

              {/* MyDeal */}
              {productPermissions.hasOwnProperty("MyDeal") && productPermissions.MyDeal !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">MyDeal:</Text>
                  {productPermissions.MyDeal === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.MyDeal !== undefined ? changedData.MyDeal : responseData.MyDeal}
                      isReadOnly
                    />
                  ) : productPermissions.MyDeal === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.MyDeal !== undefined ? changedData.MyDeal : responseData.MyDeal}
                      onChange={e => handleChange("MyDeal", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

              {/* WHS */}
              {productPermissions.hasOwnProperty("WHS") && productPermissions.WHS !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">WHS:</Text>
                  {productPermissions.WHS === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.WHS !== undefined ? changedData.WHS : responseData.WHS}
                      isReadOnly
                    />
                  ) : productPermissions.WHS === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.WHS !== undefined ? changedData.WHS : responseData.WHS}
                      onChange={e => handleChange("WHS", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

              {/* Revlon */}
              {productPermissions.hasOwnProperty("Revlon") && productPermissions.Revlon !== "hide" && (
                <Box>
                  <Text fontWeight="semibold">Revlon:</Text>
                  {productPermissions.Revlon === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.Revlon !== undefined ? changedData.Revlon : responseData.Revlon}
                      isReadOnly
                    />
                  ) : productPermissions.Revlon === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.Revlon !== undefined ? changedData.Revlon : responseData.Revlon}
                      onChange={e => handleChange("Revlon", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

            </Flex>
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            <Flex justify="space-between" mb={4}>
              {/* Size */}
              {productPermissions.hasOwnProperty("Size") && productPermissions.Size !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Size:</Text>
                  {productPermissions.Size === "view" ? (
                    <Input
                      type="text"
                      value={changedData.Size || responseData.Size}
                      isReadOnly
                      placeholder="Size"
                    />
                  ) : productPermissions.Size === "edit" ? (
                    <Input
                      type="text"
                      value={changedData.Size || responseData.Size}
                      onChange={(e) => handleChange("Size", e.target.value)}
                    />
                  ) : null}
                </Box>
              )}

              {/* Weight */}
              {productPermissions.hasOwnProperty("Weight") && productPermissions.Weight !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Weight:</Text>
                  {productPermissions.Weight === "view" ? (
                    <Input
                      type="text"
                      value={changedData.Weight || responseData.Weight}
                      isReadOnly
                      placeholder="Weight"
                    />
                  ) : productPermissions.Weight === "edit" ? (
                    <Input
                      type="text"
                      value={changedData.Weight || responseData.Weight}
                      onChange={(e) => handleChange("Weight", e.target.value)}
                    />
                  ) : null}
                </Box>
              )}

              {/* Product Country Origin */}
              {productPermissions.hasOwnProperty("countryofOrigin") && productPermissions.countryofOrigin !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Product Country Origin:</Text>
                  {productPermissions.countryofOrigin === "view" ? (
                    <Select
                      value={existingCountryOrigin ? { value: existingCountryOrigin, label: existingCountryOrigin } : null}
                      isDisabled
                      options={countryOrigin.map((origin) => ({ value: origin.name, label: origin.name }))}
                    />
                  ) : productPermissions.countryofOrigin === "edit" ? (
                    <Select
                      value={existingCountryOrigin ? { value: existingCountryOrigin, label: existingCountryOrigin } : null}
                      onChange={handleSelectCountryOfOriginChange}
                      options={countryOrigin.map((origin) => ({ value: origin.name, label: origin.name }))}
                      isClearable
                    />
                  ) : null}
                </Box>
              )}

              {/* EveryDay Low Price (Switch) */}
              {productPermissions.hasOwnProperty("EDLP") && productPermissions.EDLP !== "hide" && (
                <Box>
                  <Text fontWeight="bold">EveryDay Low Price:</Text>
                  {productPermissions.EDLP === "view" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.EDLP !== undefined ? changedData.EDLP : responseData.EDLP}
                      isReadOnly
                    />
                  ) : productPermissions.EDLP === "edit" ? (
                    <Switch
                      colorScheme="teal"
                      isChecked={changedData.EDLP !== undefined ? changedData.EDLP : responseData.EDLP}
                      onChange={e => handleChange("EDLP", e.target.checked)}
                    />
                  ) : null}
                </Box>
              )}

            </Flex>
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            <Flex justify="space-between" mb={4}>
              {/* Product Categories */}
              {productPermissions.hasOwnProperty("ProductCategories") && productPermissions.ProductCategories !== "hide" && (
                <Box>
                  <Text fontWeight="bold">Product Categories:</Text>
                  {productPermissions.ProductCategories === "view" ? (
                    <Select
                      value={existingCategories.map((category) => ({ value: category, label: category }))}
                      isDisabled
                      options={existingCategories.map((category) => ({ value: category, label: category }))}
                      isMulti
                      isClearable
                    />
                  ) : productPermissions.ProductCategories === "edit" ? (
                    <Select
                      value={existingCategories.map((category) => ({ value: category, label: category }))}
                      onChange={handleSelectCategory}
                      options={existingCategories.map((category) => ({ value: category, label: category }))}
                      isMulti
                      isClearable
                    />
                  ) : null}
                </Box>
              )}

            </Flex>

            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
                 {/* Permission Handling for AddCategoryDropdown */}
                 {productPermissions.hasOwnProperty("ProductCategories") && productPermissions.ProductCategories !== "hide" && (
            <Flex mb={4}>
          
              <Flex alignItems="center">
                <Text fontWeight="bold">Add new Category:</Text>
              </Flex>

              <Flex ml={6}>
               
                  <AddCategoryDropdown
                    parentCategories={categoryData}
                    onSelectParentCategory={(selectedOption) => {
                      console.log("Selected Parent Category:", selectedOption);
                    }}
                    onAddCategories={handleAddCategories}
                    isDisabledSelection={productPermissions.ProductCategories === "view"}
                  />
              
              </Flex>

            </Flex>
              )}
            <Divider orientation="horizontal" borderColor="gray.300" h="80%" mb={4} />
            {/* Long Description */}
            {productPermissions.hasOwnProperty("LongDescription") && productPermissions.LongDescription !== "hide" && (
              <Box mt={6} mb={4}>
                <Text fontWeight="bold">Long Description:</Text>
                {productPermissions.LongDescription === "view" ? (
                  <Textarea
                    value={changedData.LongDescription || responseData.LongDescription}
                    isReadOnly
                    size="sm"
                    height="100px"
                    width="100%"
                  />
                ) : productPermissions.LongDescription === "edit" ? (
                  <Textarea
                    value={changedData.LongDescription || responseData.LongDescription}
                    onChange={(e) => handleChange("LongDescription", e.target.value)}
                    size="sm"
                    height="100px"
                    width="100%"
                  />
                ) : null}
              </Box>
            )}


<Flex justifyContent={"flex-end"}>
      <Button 
        colorScheme="teal" 
        onClick={submitProductdata} 
        isDisabled={!hasEditPermission}  // Disable if no "edit" permission
      >
        Update
      </Button>
    </Flex>
          </Box>
        )}

      </Box>
    </Card>
  );
}
